export default __webpack_public_path__ + "static/media/NotoSansKR-Regular.0f026b95.ttf";